module.exports = __webpack_public_path__ + "img/api-step-2@2x.a3a1eacb.png";